// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__Ug4HZ","balanceDisclaimer":"posDashboard_balanceDisclaimer__3tVDH"};